import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { routes } from '../../../router/routes'
import { BaseNotificationModal } from './base-modal'
import { useStyles } from './style'

/* Org recommendations — no dedicated page exists, so the modal carries the
 * list; the "Your organisation recommends" notification opens it.
 * TODO(API): rows are mock content — the payload brings real locationIds, at
 * which point each row deep-links to its content page. */
const ORG_ITEMS = [
  ['Running Meetings People Don’t Dread', 'Article • 8 mins'],
  ['The Art of the Written Update', 'Skill Bite • 10 mins'],
  ['Listening as a Leadership Skill', 'Expert interview • 15 mins']
]

export const OrgRecommendsModal = ({ open, onClose }) => {
  const classes = useStyles()
  const navigate = useNavigate()
  return (
    <BaseNotificationModal open={open} onClose={onClose} title='Your organisation recommends' dataTest='notification-modal-org-recommends'>
      <Typography color='textSecondary' className={classes.intro}>
        Your L&amp;D team curated three resources to support this quarter&apos;s focus on communication:
      </Typography>
      {ORG_ITEMS.map(([title, meta]) => (
        <Box key={title} className={classes.resourceCard}>
          <Typography className={classes.rowTitle}>{title}</Typography>
          <Typography variant='body2' color='textSecondary'>{meta}</Typography>
        </Box>
      ))}
      <Button
        variant='contained'
        color='primary'
        onClick={() => { onClose(); navigate(routes.home.path) }}
        className={classes.inlineCta}
        data-test='notification-org-recommends-cta'
      >
        Explore more content
      </Button>
    </BaseNotificationModal>
  )
}

export default OrgRecommendsModal
